import { baseApi } from '@api/baseApi';
import { DataListItem } from '@api/shared-types/DataListItem';



const listDataApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		
		getAllCodeReasons: builder.query<DataListItem[], void>({
			query: () => ({
				url: 'ListData/GetAllCodeReasons'
			}),
			providesTags: ['allCodeReasons'],
		}),


		getPlantsList: builder.query<DataListItem[], { userId: string }>({
			query: ({ userId }) => ({
				url: 'ListData/GetPlantsList',
				params: { ovsCustomerId: process.env.OVS_CUSTOMER_ID, userId }
			}),
			providesTags: ['plantsList'],
		}),


		getDistrictsList: builder.query<DataListItem[], { userId: string }>({
			query: ({ userId }) => ({
				url: 'ListData/GetDistrictsList',
				params: { ovsCustomerId: process.env.OVS_CUSTOMER_ID, userId }
			}),
			providesTags: ['districtsList'],
		}),
		

		getRegionsList: builder.query<DataListItem[], { userId: string }>({
			query: ({ userId }) => ({
				url: 'ListData/GetRegionsList',
				params: { ovsCustomerId: process.env.OVS_CUSTOMER_ID, userId }
			}),
			providesTags: ['regionsList'],
		}),
	}),
});


export const {
	useGetAllCodeReasonsQuery,
	useGetPlantsListQuery,
	useGetDistrictsListQuery,
	useGetRegionsListQuery } = listDataApi;